// extracted by mini-css-extract-plugin
export var mainTitle = "HeroSection-module--mainTitle--8+4Sp";
export var section = "HeroSection-module--section--8xle6";
export var staticBg = "HeroSection-module--staticBg--x4IkV";
export var subtitle = "HeroSection-module--subtitle--922N+";
export var text = "HeroSection-module--text--ZG5IH";
export var textContainer = "HeroSection-module--textContainer--+jiIo";